@if (step) {
  <svg
    id="overlay"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()">
    <defs>
      <mask id="overlay-mask">
        <rect x="0" y="0" width="100%" height="100%" fill="white"></rect>
        <rect
          id="highlight"
          rx="5"
          [attr.x]="highlightLeft"
          [attr.y]="highlightTop"
          [attr.width]="highlightWidth"
          [attr.height]="highlightHeight"
          fill="black"></rect>
      </mask>
    </defs>
    <rect
      x="0"
      y="0"
      width="100vw"
      height="100vh"
      fill="black"
      fill-opacity="0.4"
      mask="url(#overlay-mask)"></rect>
  </svg>
}

<article
  class="container"
  [ngStyle]="{
    top: top,
    left: left,
    bottom: bottom,
  }"
  #tour
  [hidden]="!step"
  [ngClass]="[class]">
  <header>
    <h2>{{ step?.title ?? '' | translate }}</h2>
    <button
      app-icon-button
      src="assets/images/icons/close.svg"
      alt="{{ Translations.Close | translate }}"
      (click)="close(false)">
      {{ Translations.Close | translate }}
    </button>
  </header>
  <main>
    @for (content of step?.content ?? []; track content) {
      <div>{{ content | translate }}</div>
    }
  </main>
  <span class="arrow"></span>
  <footer>
    <nav>
      <button
        (click)="previous()"
        (keydown.enter)="previous()"
        [ngClass]="{ disabled: index === 0 }">
        <app-icon src="assets/images/icons/previous.svg"></app-icon>
        {{ Translations.Previous | translate }}
      </button>
      <span>{{ index + 1 }}/{{ max }}</span>
      @if (index + 1 < max) {
        <button (click)="next()" (keydown.enter)="next()">
          {{ Translations.Next | translate }}
          <app-icon src="assets/images/icons/next.svg"></app-icon>
        </button>
      }
      @if (index + 1 >= max) {
        <button (click)="close(true)" (keydown.enter)="close(true)">
          <strong>{{ Translations.End | translate }}</strong>
        </button>
      }
    </nav>
  </footer>
</article>
